import React, { useState, useRef, useEffect } from 'react';
import { sanitizeTextMessage } from '../../../utilities/messagingFunctions';

function TextInputBar({handleFileUpload, from, inputValue, handleChange, handleHeight, handleCursorPosition, canEditContent , dropEvent = false}) {
    const isFeature875Enabled = process.env.REACT_APP_FUNNEL_FEATURE_875 === 'true'
    const inputRef = useRef(null);
    const [showCharLimitError , setShowCharLimitError] = useState(false);
    const maxChar = 1500

     const handleInputChange = (e) => {
        const text = e.currentTarget.innerText;
        const processedText = sanitizeTextMessage(text);

        if (text.length > maxChar) {
            e.currentTarget.innerText = inputValue;
            setShowCharLimitError(true);
        } else {
            setShowCharLimitError(false);
            handleChange(processedText);
        }
    };

       const handleKeyDown = (e) => {
        const text = inputRef.current.innerText;
        if (text.length >= maxChar && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            e.preventDefault();
            setShowCharLimitError(true);
        }
    };

    useEffect(() => {
        if (inputRef.current && inputRef.current.innerText !== inputValue) {
            inputRef.current.innerText = inputValue;
        }
    }, [inputValue]);

    useEffect(() => {
        const updateHeight = () => {
            const height = inputRef.current.clientHeight;
            if(from==='bigConvo'){
                handleHeight((height + 50))
            }
            else{
                handleHeight(height)
            }
        };
        const updateCursorPosition = () => {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preSelectionRange = range.cloneRange();
                preSelectionRange.selectNodeContents(inputRef.current);
                preSelectionRange.setEnd(range.startContainer, range.startOffset);
                handleCursorPosition(preSelectionRange.toString().length);
            }
        };
        updateHeight(); // Update height when component mounts
        //inputRef.current.addEventListener('input', updateHeight); // Update height when content changes
        inputRef.current.addEventListener('input', updateCursorPosition);
        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener('input', updateHeight); // Cleanup
                inputRef.current.removeEventListener('input', updateCursorPosition);
            }
        };
    }, []);
    const handlePaste = (e) => {
        e.preventDefault(); // Prevent the default paste behavior
        // Extract plain text from the clipboard
        const plainText = e.clipboardData.getData('text/plain');
        // Insert the plain text into the div
        document.execCommand('insertText', false, plainText);
    };

    useEffect(() => {
    const preventDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    window.addEventListener('dragover', preventDefault);
    window.addEventListener('drop', preventDefault);

    return () => {
      window.removeEventListener('dragover', preventDefault);
      window.removeEventListener('drop', preventDefault);
    };
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (canEditContent && dropEvent) {
      handleFileUpload(e);
    }
  };

  const handleDragOver = (e) => {
    if (canEditContent && dropEvent) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

    return (
        <>
           {showCharLimitError && (
                <span style={{ color: 'red', textAlign: 'center', width: '100%', display: 'block' }}>
                    Maximum 1,500 characters, send and start new message 
                </span>
            )}
           <div
            className={isFeature875Enabled===true ? (canEditContent===true ? "demo" : "demoInactive") : 'demo'} // Changed 'class' to 'className'
            contentEditable={isFeature875Enabled===true ? canEditContent ?? false : 'true'}
            ref={inputRef}
            suppressContentEditableWarning={true}
            onInput={handleInputChange}
            onPaste={handlePaste}
            onKeyDown={handleKeyDown}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
           >
           </div>
        </>
       
    );
}

export default TextInputBar;
